import { defaultTheme } from "react-admin";

export const theme = {
    ...defaultTheme,
    components: {
      ...defaultTheme.components,
      RaDatagrid: {
        styleOverrides: {
          root: {
            ".RaDatagrid-headerCell": {
              paddingTop: "14px",
              paddingBottom: "14px",
            },
            ".RaDatagrid-rowCell": {
              paddingTop: "14px",
              paddingBottom: "14px",
            },
          },
        },
      },
      RaList: {
        styleOverrides: {
          root: {
            marginTop: "15px",
            ".RaList-content": {
              marginTop: "15px",
            },
          },
        },
      },
      RaSidebar: {
        styleOverrides: {
          root: {
            marginTop: "35px",
            ".RaSidebar-fixed": {
              position: "relative",
            },
            ".MuiMenuItem-root": {
              paddingTop: "12px",
              paddingBottom: "12px",
              width: '240px',
            },
          },
        },
      },
      RaAppBar: {
        styleOverrides: {
          root: {
            padding:'5px 0'
          },
        },
      },
    },
  };